// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCticyiy8NvA4pLdv5aGimWjQ0b2By7VtU",
  authDomain: "curo-health-demo.firebaseapp.com",
  projectId: "curo-health-demo",
  storageBucket: "curo-health-demo.firebasestorage.app",
  messagingSenderId: "1012330715146",
  appId: "1:1012330715146:web:3bfe6ca2bf80dbff34a7f3"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Cloud Messaging (push notifications)
export const messaging = getMessaging(app);

// Public VAPID key from Firebase Console > Project Settings > Cloud Messaging > Web Push certificates
const VAPID_KEY = "BNYT8aPEWgDSlUwQtAWBZVdjNJ0Bwo5NclH0hijS1qTGbeFAbw1-bZJiBlIToQ8DGWUmelQNyRx5gXjIB6N8uvE";

// Call this after the user grants notification permission
export async function requestFcmToken(): Promise<string | null> {
  try {
    const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration
    });
    return token;
  } catch (err) {
    console.error("Failed to get FCM token:", err);
    return null;
  }

}

export async function refreshFcmToken(): Promise<string | null> {
  if (typeof Notification === "undefined" || Notification.permission !== "granted") return null;
  return requestFcmToken();
}

// Foreground message handler (app open, tab focused)
export function onForegroundMessage(callback: (payload: any) => void) {
  return onMessage(messaging, callback);
}